var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 22.3974L15.9998 17.3974L20.9998 22.3974L22.3998 20.9974L17.3998 15.9974L22.3998 10.9974L20.9998 9.5974L15.9998 14.5974L10.9998 9.5974L9.59984 10.9974L14.5998 15.9974L9.59984 20.9974L10.9998 22.3974ZM15.9998 29.3307C14.1776 29.3307 12.4554 28.9807 10.8332 28.2807C9.21095 27.5807 7.79428 26.6252 6.58317 25.4141C5.37206 24.2029 4.4165 22.7863 3.7165 21.1641C3.0165 19.5418 2.6665 17.8196 2.6665 15.9974C2.6665 14.153 3.0165 12.4196 3.7165 10.7974C4.4165 9.17517 5.37206 7.76406 6.58317 6.56406C7.79428 5.36406 9.21095 4.41406 10.8332 3.71406C12.4554 3.01406 14.1776 2.66406 15.9998 2.66406C17.8443 2.66406 19.5776 3.01406 21.1998 3.71406C22.8221 4.41406 24.2332 5.36406 25.4332 6.56406C26.6332 7.76406 27.5832 9.17517 28.2832 10.7974C28.9832 12.4196 29.3332 14.153 29.3332 15.9974C29.3332 17.8196 28.9832 19.5418 28.2832 21.1641C27.5832 22.7863 26.6332 24.2029 25.4332 25.4141C24.2332 26.6252 22.8221 27.5807 21.1998 28.2807C19.5776 28.9807 17.8443 29.3307 15.9998 29.3307ZM15.9998 27.3307C19.1554 27.3307 21.8332 26.2252 24.0332 24.0141C26.2332 21.8029 27.3332 19.1307 27.3332 15.9974C27.3332 12.8418 26.2332 10.1641 24.0332 7.96406C21.8332 5.76406 19.1554 4.66406 15.9998 4.66406C12.8665 4.66406 10.1943 5.76406 7.98317 7.96406C5.77206 10.1641 4.6665 12.8418 4.6665 15.9974C4.6665 19.1307 5.77206 21.8029 7.98317 24.0141C10.1943 26.2252 12.8665 27.3307 15.9998 27.3307Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRounded);
export default __webpack_public_path__ + "static/media/close-rounded.13cd9aa1fb4d2a171a62ad968f029426.svg";
export { ForwardRef as ReactComponent };